import createRangeSelectFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/RangeSelectFilter/factory";

import { DOLLAR_PREFIX } from "../../constants/index";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { formatMoney } from "../../utils/numberFormatters";
import { defineDescriptionFilter } from "../defineSourcedFilter";

export const totalFundingAmountDefinition = defineDescriptionFilter({
    key: "totalFundingAmount",
    apiCategory: leadsFilterApiCategory.totalFundingAmount,
    category: leadsFilterCategoryMap.company,
    trackingName: "total funding",

    render: ({ description }) =>
        createRangeSelectFilter({
            key: "totalFundingAmount",
            trackingName: "total funding",
            apiCategory: "leadsFilters",
            category: leadsFilterCategoryMap.company,

            translationKey: "fundingGroup",
            rangeOptions: {
                fieldName: "funding",
                labelKey: "si.lead_gen_filters.group.fundingGroup.hint",
                buckets: description.bucketsDescription.funding,
                placeholderPrefix: DOLLAR_PREFIX,
                formatValue: formatMoney,
            },
        }),
});
